// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const helioptile: PokeData = {
  "id": 694,
  "name": "helioptile",
  "height": 5,
  "weight": 60,
  "base_experience": 58,
  "types": [
    PokeType.ELECTRIC,
    PokeType.NORMAL
  ],
  "api_moves": [
    "pound",
    "razor-wind",
    "tail-whip",
    "thunder-shock",
    "thunderbolt",
    "thunder-wave",
    "thunder",
    "quick-attack",
    "mud-slap",
    "charge",
    "volt-switch",
    "bulldoze",
    "parabolic-charge",
    "electrify"
  ],
  "moves": [
    "thunder-shock",
    "thunderbolt",
    "thunder",
    "quick-attack",
    "mud-slap",
    "volt-switch",
    "growl",
    "electric-wrath",
    "scratch",
    "protect",
    "electric-terrain",
    "thunder-punch",
    "headbutt"
  ],
  "evolution_chain": {
    "id": 356,
    "item": null,
    "species": [
      {
        "name": "helioptile",
        "order": 695,
        "types": [
          PokeType.ELECTRIC,
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "heliolisk",
        "order": 696,
        "types": [
          PokeType.ELECTRIC,
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 694,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "sun-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 41,
    "speed": 70,
    "ability_power": 61
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
